import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import ctaTypes from '../../../../enums/CTA.enums';
import { googleClickCtaEvent } from '../../../../utils/analytics';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import CTA from '../../../@shared/cta';
import Icon from '../../../@shared/icon';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { TCardButtons } from '../../types/cardColumnLayout.types';

const CardButtons: FC<TCardButtons> = ({
  isEE,
  cta1,
  cta2,
  title,
  cardIndex,
  isWide,
  showPopupWithSplitModule,
  splitModuleLabel,
  handleSplitModuleModal,
}) => (
  <div className={'card__buttons'}>
    {showPopupWithSplitModule && (
      <div className="card__primary">
        <CTA
          type={ctaTypes.primaryRed}
          extraClassName="card__buttons--primary-cta"
          onClick={(): void => {
            handleSplitModuleModal(true);
            googleClickCtaEvent('Button', '#', splitModuleLabel);
          }}
        >
          {splitModuleLabel}
        </CTA>
      </div>
    )}
    {(isEE || (cta1?.value?.text && cta1?.value?.href)) && (
      <div className="card__primary">
        <CTA
          field={cta1}
          type={ctaTypes.primaryRed}
          target={targetLinkdsk(cta1, isWide)}
          extraClassName="card__buttons--primary-cta"
          onClick={() => googleClickCtaEvent('Button', cta1?.value.text ?? cta1?.value.title, title?.value || '', cardIndex + 1)}
        />
      </div>
    )}
    {(isEE || (cta2?.value?.text && cta2?.value?.href)) && (
      <div className="card__secondary">
        <RoutableSitecoreLink
          field={cta2}
          editable={true}
          target={targetLinkdsk(cta2, isWide)}
          className="card__buttons--secondary-cta"
          onClick={() => googleClickCtaEvent('Button', cta2?.value.text ?? cta2?.value.title, title?.value || '', cardIndex + 1)}
        />
        <Icon iconName="arrow-simple-right" size={iconSize.dsk} extraClassName="card__secondary--icon" />
      </div>
    )}
  </div>
);

export default CardButtons;
